import React, { useContext, useEffect, useState } from 'react'
import { CommonNavbar } from '../../../components/CommonNavbar'
import { getUrlParameter } from '../../../constants/commonFunction';
import path from '../../../constants/pathConstants';
import "./index.css";
import { ApiDispatchContext } from '../../../context/ApiContext';
import GenricPetitionerForm from '../../../components/PetitionerForm/GenricPetitionerForm';
import { utList } from '../../../constants/unionTerritories';
import { imageBaseUrl } from '../../../utils/constants';
import AcceptButtons from '../../OpenCasesDetailsPage/AcceptButtons';
import ErrorAlert from '../../../components/ErrorAlert';
import SuccessMessage from '../../../components/SuccessMssgDisplay';
import DocumentUpload from '../../../components/DocumentUpload';
import FilterPopUp from '../../../components/FilterPopUp';
import UploadInvoiceFormBottom from '../UploadInvoiceFormBottom';
import Loader from '../../../components/Loader';
import { useNavigate } from 'react-router-dom';

const index = () => {
const [invoiceFormData, setInvoiceFormData] = useState([]);
const [gstApplicable, setGstApplicable] = useState(false);
const [chargesTotal, setChargesTotal] = useState(0);
const [cgstAmount, setCgstAmount] = useState(0);
const [sgstAmount, setSgstAmount] = useState(0);
const [ugstAmount, setUgstAmount] = useState(0);
const [igstAmount, setIgstAmount] = useState(0);
const [gstType, setGstType] = useState("");
const [tdsAmount, setTdsAmount] = useState(0);
const [tdsPercent, setTdsPercent] = useState(0);
const [totalAmount, setTotalAmount] = useState(0);
const [modal, setModal] = useState(false);
const [modalTitle, setModalTitle] = useState("");
const [modalBody, setModalBody] = useState("");
const [open, setOpen] = useState(false);
const [showSuccessMessage, setShowSuccessMessage] = useState(false);
const [allParameterValuesNotEmpty, setAllParameterValuesNotEmpty] = useState(false);
const [showLoader, setShowLoader] = useState(false);
const [renamed_block_parameter , setrenamed_block_parameter] = useState('');
const [docsUploaded,setDocsUploaded] = useState(false);
const toggle = () => setModal(!modal);
const caseId = getUrlParameter("case");
const casetype = getUrlParameter("casetype");
let invoiceId = Number(getUrlParameter('invoiceId'));
const navigate = useNavigate();
const api = useContext(ApiDispatchContext);
const employeeDetails = JSON.parse(localStorage.getItem("Employment-master"));
const vendorLocation = employeeDetails?.employee?.vendor_state;
const gstPercent = 9

    const uploadDocuments = async(file, filetype) => {
      setShowLoader(true);
      await api.uploadDocuments(file).then(data=>{
          if(data?.data && data?.data?.success) {
            let tempdata = {};
            let newPetitioners = { ...invoiceFormData}; 
            Object.assign(tempdata, newPetitioners);
            let newdata = {
              document_name: data?.data?.data?.document_name,
              document_path: data?.data?.data?.document_path,
              document_size: data?.data?.data?.document_size,
              document_type: filetype,
            }
            tempdata.documents.push(newdata)
            setInvoiceFormData(tempdata); 
            setOpen(!open);
            setShowLoader(false);
          } else {
            setModalTitle("Error");
            if(data?.data?.error && data?.data?.message){
              setModalBody(data?.data?.message)
            } else {
              setModalBody('Please try after sometime');
            }
            toggle();
            setShowLoader(false);
          }
        }).catch(err=>{
          setModalTitle("Error");
          if (err && err?.response && err?.response?.data && err?.response?.data?.message) {
            setModalBody(err?.response?.data?.message);
          } else {
            setModalBody('Please try after sometime.');
          }
          toggle();
          setShowLoader(false);
        });
    }

  const handleChange = (value, index) => {
    setInvoiceFormData(prev => {
      const updatedParameters = [...prev.singleInvoiceParameters];
     ["CGST/SGST","UTGST","IGST"]?.includes(value)&& setGstType(value)
      updatedParameters[index] = {
        ...updatedParameters[index],
        parameter_value: value?.target?.value || value // depending on your input structure
      };
      return {
        ...prev,
        singleInvoiceParameters: updatedParameters
      };
    });
  };

    const onClose = (e,index) =>{
      e.stopPropagation();
      let tempArray = JSON.parse(JSON.stringify(invoiceFormData));
      let tempDocs = JSON.parse(JSON.stringify(tempArray?.documents));
      tempDocs.splice(index,1);
      tempArray.documents = tempDocs
      setInvoiceFormData(tempArray)
    }
  

  const handlePetChange = (value, petIndex, petInpIndex, parameter_name) => {
    const newPetitioners = { ...invoiceFormData };
  
    if (parameter_name === "charge_amount") {
      const decimalPart = value.toString().split(".")[1];
      if (!decimalPart || decimalPart.length <= 2) {
        newPetitioners.multipleInvoiceParameters[petIndex][petInpIndex].parameter_value = value;
      } else {
        return; // If more than 2 decimals, skip update
      }
    } else {
      newPetitioners.multipleInvoiceParameters[petIndex][petInpIndex].parameter_value = value;
    }
    let charges = 0;
    if(parameter_name && parameter_name === "charge_amount") {
        newPetitioners?.multipleInvoiceParameters?.forEach(item => {
          charges = Number(item[1]?.parameter_value) + charges;
        })
        if(tdsPercent) {
          setChargesTotal(charges-(charges/tdsPercent));
        } else {
          setChargesTotal(charges)
        }
        tdsPercent && setTdsAmount(charges/tdsPercent);
      }
    setInvoiceFormData(newPetitioners);
  };
    const addRowClick = () => {
      let tempArray = JSON.parse(JSON.stringify(invoiceFormData));
      let temp = JSON.parse(JSON.stringify(tempArray?.multipleInvoiceParameters[0]));
      if (temp) {
        temp.forEach(item => {
          item.parameter_value = "";
        });
      }
      tempArray.multipleInvoiceParameters.push(temp);
      setInvoiceFormData(tempArray);
    }

     const removeRowClick = (index) => {
        let tempArray = JSON.parse(JSON.stringify(invoiceFormData));
        let temp = JSON.parse(JSON.stringify(tempArray?.multipleInvoiceParameters));
        temp.splice(index, 1);
        tempArray.multipleInvoiceParameters = temp;
        let charges = 0;
        tempArray?.multipleInvoiceParameters?.forEach(item => {
          charges = Number(item[1]?.parameter_value) + charges;
        })
        if(tdsPercent) {
          setChargesTotal(charges-(charges/tdsPercent));
        } else {
          setChargesTotal(charges)
        }
        tdsPercent && setTdsAmount(charges/tdsPercent);
        setInvoiceFormData(tempArray);
      }

    function getFormDataWithMultiParams() {
       let result = {};
       const temp = [];
       let doSubmit = true;
       invoiceFormData?.singleInvoiceParameters?.forEach(pay => {
         if(pay?.parameter_name == "product_category" || (gstApplicable == true && pay?.parameter_name !== "gst_number")) {
           if(pay?.parameter_value === "" || pay?.parameter_value == null) {
             setModalTitle("Error");
             setModalBody("Please fill all the required fields");
             toggle();
             doSubmit = false;
             return
           }
         } 
         if (pay?.parameter_type !== "upload") {
           result[pay.parameter_name] = pay?.parameter_value ? pay?.parameter_value : null;
         }
       });
       invoiceFormData?.multipleInvoiceParameters?.map(item => {
         let obj = {};
         item.map(ele => {
           obj[ele.parameter_name] = ele?.parameter_value ? ele?.parameter_value : null;
         });
         temp.push(obj);
       });
       const multipleParameter = "multipleParameter";
       result[multipleParameter] = temp;
       result["charge_total"] = chargesTotal;
       result["tds_value"] = tdsAmount;
       result["cgst"] = cgstAmount;
       result["sgst"] = sgstAmount;
       result["ugst"] = ugstAmount;
       result["igst"] = igstAmount;
       result["total_amount"] = totalAmount.toFixed(2);
       if(doSubmit) {
         return result;
       } else {
         return result = null;
       }
     }

       const getdocumentsArray = () => {
         let tempdata = [];
         let config = [];
         Object.assign(tempdata, invoiceFormData);
         if (tempdata?.documents) {
           return tempdata?.documents;
         } else {
           return config;
         }
       }
     
  const onSubmit = () => {
    setShowLoader(true);
    setShowSuccessMessage(false);
    const formData = getFormDataWithMultiParams();
    if(formData) {
      const payload = {
        "caseId": Number(caseId),
        "invoiceId":invoiceId,
        "formData": formData,
        "documents": getdocumentsArray(),
        "rejectedInvoice":["rejectedInvoice"].includes(casetype),
        "invoiceType": casetype === "opencase" || casetype === "allottedcase"
        ? "open"
        : casetype === "reinvestigatecases"
        ? "reinvestigated"
        : "rejectedInvoice",
      }
    api.editInvoiceSubmitFormDetails(payload).then((data) =>{
        setModalTitle("Sucess");
        setShowLoader(false);
        if(data?.data?.success){
        setModalBody(data?.data?.message);
        navigate(path.UPLOAD_INVOICE_DETAILS + "?" + btoa("case=" + caseId + "&casetype=" + casetype))
        }
    }).catch(err => {
        setModalTitle("Error");
        if (err && err?.response && err?.response?.data && err?.response?.data?.message) {
          setModalBody(err?.response?.data?.message);
        } else {
          setModalBody('Please try after sometime.');
        }
        setShowLoader(false);
        toggle();
      })
  }
}

  const filterToggle = (temprenamed_block_parameter) => {
    setrenamed_block_parameter(temprenamed_block_parameter);
    setOpen(!open);
  }
  

useEffect(() => {
    api.invoiceIdDetails({ params: { "invoiceId": invoiceId, "caseId": caseId }, withCredentials: true }).then(data=>{
      if(data?.data && data?.data?.success){
        const invoiceData = data?.data?.data; 
        setInvoiceFormData(invoiceData);
        const gstObj = invoiceData?.singleInvoiceParameters?.find((item)=>item?.parameter_name ==="gst_type");
        setGstType(gstObj?.parameter_value||"")
        let gstApplicableStatus=""
        for(let i=0; i < invoiceData?.singleInvoiceParameters?.length; i++) {
          if(invoiceData?.singleInvoiceParameters[i]?.block_parameters_id === 6) {
            gstApplicableStatus = invoiceData?.singleInvoiceParameters[6]?.parameter_value 
            setGstApplicable(gstApplicableStatus === "No" ? false : true );
        }
    }
        const invoiceDetails = invoiceData?.invoiceDetails;
        setChargesTotal(Number(invoiceDetails?.charge_total));
        setCgstAmount(invoiceDetails?.cgst ? Number(invoiceDetails?.cgst) : 0.00);
        setSgstAmount(invoiceDetails?.sgst ? Number(invoiceDetails?.sgst) : 0.00);
        setUgstAmount(invoiceDetails?.utgst ? Number(invoiceDetails?.utgst): 0.00);
        setIgstAmount(invoiceDetails?.igst ? Number(invoiceDetails?.igst): 0.00);
        setTdsAmount(invoiceDetails?.tds_value ? Number(invoiceDetails?.tds_value): 0.00);
        setTdsPercent(invoiceDetails?.tds_per ? Number(invoiceDetails?.tds_per): 0)
        setTotalAmount(Number(invoiceDetails?.total_amount));
      } else {
        setModalTitle("Error");
        if(data?.data?.error && data?.data?.message){
          setModalBody(data?.data?.message)
        } else{
          setModalBody('Please try after sometime');
        }
        toggle();
      }
    })
    .catch(err=>{

        setModalTitle("Error");
        if (err && err?.response && err?.response?.data && err?.response?.data?.message) {
          setModalBody(err?.response?.data?.message);
        } else {
          setModalBody('Please try after sometime.');
        }
        toggle();
      })
  }, [])

   useEffect(() => {
     const amount = tdsPercent ? chargesTotal + tdsAmount : chargesTotal;
      const gstData = gstApplicable ? (amount*gstPercent)/100 : 0;
      if(gstType === "UTGST") {
        setUgstAmount(gstData + gstData);
        setTotalAmount((amount + gstData + gstData) - tdsAmount);
      } else if (gstType ==="IGST") {
        setIgstAmount(gstData+gstData);
        setTotalAmount((amount + gstData + gstData)  - tdsAmount);
      } else  {
        setCgstAmount(gstData);
        setSgstAmount(gstData);
        setTotalAmount((amount + gstData + gstData) - tdsAmount);
      }
    }, [chargesTotal, gstApplicable, tdsAmount, gstType, tdsPercent])

      useEffect(() => {
        if(invoiceFormData && invoiceFormData?.singleInvoiceParameters?.length > 0 && invoiceFormData?.multipleInvoiceParameters?.length > 0){
          const isAllSingleValuesNotEmpty = invoiceFormData?.singleInvoiceParameters.every(obj => {
            if(obj?.parameter_type != "upload"){
              if(!gstApplicable){
                 if(obj?.parameter_name !=="gst_number"){
                  return  (obj?.value != null && obj?.value !== "") || (obj?.parameter_value != null && obj?.parameter_value !== "")
                 }
              } else {
                (obj?.value != null && obj?.value !== "") || (obj?.parameter_value != null && obj?.parameter_value !== "")
              } 
            }
            return true
          });
          const isAllMultiValuesNotEmpty = invoiceFormData?.multipleInvoiceParameters.every(arr => {
            return arr.every(obj =>obj?.parameter_value != null && obj?.parameter_value !== "");
          });
          setAllParameterValuesNotEmpty(isAllSingleValuesNotEmpty && isAllMultiValuesNotEmpty && invoiceFormData?.documents && invoiceFormData?.documents?.length)
        }
      }, [invoiceFormData])
  return (
<div data-testid="newInvoice-wrapper" className="newInvoice-wrapper">
     <CommonNavbar title="Edit Invoice" search={false} download={false} backButton={path.UPLOAD_INVOICE_DETAILS + "?" + btoa("case=" + caseId + "&casetype=" + casetype)} navbarname='Edit Invoice' />
     <div className="input-container" style={{marginBottom: '0px'}}>
      {invoiceFormData && invoiceFormData?.singleInvoiceParameters && invoiceFormData?.singleInvoiceParameters?.length > 0 && invoiceFormData?.singleInvoiceParameters?.map((ele, index) => {
        if(!index) {
                   return <div style={{marginLeft: "10px", paddingTop: "15px"}}> <p style={{fontWeight: 500, fontSize: "14px"}}>Reference # {ele?.parameter_value}</p></div>
                 } else if(ele?.parameter_name === "product_category" || ele?.parameter_name === "hdfc_ergo_gst_number" || ele?.parameter_name === "claim_number" || ele?.parameter_name === "agency_name") {
                   return <GenricPetitionerForm isDisabled={true} ifRequired={true} key={index} config={ele} formcolor={"rgba(124, 20, 75, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(event) => handleChange(event, index)} showLabel={true} />
                 } else if(ele?.parameter_name === "gst_number") {
                   if(ele?.parameter_value) {
                   return <GenricPetitionerForm isDisabled={true} ifRequired={true} key={index} config={ele} formcolor={"rgba(124, 20, 75, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(event) => handleChange(event, index)} showLabel={true} />
                   } else {
                     return null;
                   }
                 } else if(ele?.parameter_name === "gst_applicable") {
                   return <GenricPetitionerForm isDisabled={true} ifRequired={true} key={index} config={ele} formcolor={"rgba(124, 20, 75, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(event) => handleChange(event, index)} showLabel={true} />
                 } else {
                   return <GenricPetitionerForm isDisabled={false} ifRequired={true} key={index} config={ele} formcolor={"rgba(44, 114, 180, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(event) => handleChange(event, index)} showLabel={true} />
                 }
               })}
      {invoiceFormData && invoiceFormData?.multipleInvoiceParameters && invoiceFormData?.multipleInvoiceParameters?.length > 0 && invoiceFormData?.multipleInvoiceParameters?.map((pet,petIndex) => {
        return (
                  <div className="multiField-row" key={petIndex}>
                    <div className="serialNum">
                      <label>Sr. No.</label>
                      <p>{petIndex+1}</p>
                    </div>
                    {Array.isArray(pet) && pet.map((petInp, petInpIndex) => {
                      if(petInp?.parameter_name === "charge_amount") {
                        return <GenricPetitionerForm isDisabled={false} ifRequired={true} key={petInpIndex} config={petInp} formcolor={"rgba(44, 114, 180, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(value) => handlePetChange(value, petIndex, petInpIndex, petInp?.parameter_name)} showLabel={true} />
                      } else {
                        return <GenricPetitionerForm isDisabled={false} ifRequired={true} key={petInpIndex} config={petInp} formcolor={"rgba(44, 114, 180, 0.1)"} formName={"NewInvoiceBlockForm"} handleChange={(value) => handlePetChange(value, petIndex, petInpIndex)} showLabel={true} />
                      }
                    })}
                    {petIndex !== 0 && <button data-testid="AddNewInvoice1" className='closeIcon' onClick={() => removeRowClick(petIndex)}><img src={`${imageBaseUrl}/close.png`} alt="close" /></button>}
                  </div>
                  )
                })}
           <div className="addRowWrapper">
               <button data-testid="AddNewInvoice2" onClick={() => addRowClick()} className="addRow">+Add row</button>
             </div>
             <div className="chargesDetail">
               <div className="chargesDetail-row">
                 <p>Charge Total</p>
                 <p>{Number(chargesTotal).toFixed(2)}</p>
               </div>
               {tdsPercent>0 &&  (
                <div className="chargesDetail-row">
                <p>TDS Deduction</p>
                <p>{tdsAmount.toFixed(2)}</p>
              </div>
              )}
               {gstType ==="UTGST" ? (
                  <div className="chargesDetail-row">
                    <p>UTGST</p>
                    <p>{ugstAmount.toFixed(2)}</p>
                  </div>
                ) : gstType ==="IGST" ? 
                <div className="chargesDetail-row">
                      <p>IGST</p>
                      <p>{igstAmount.toFixed(2)}</p>
                    </div>
                :
                (
                  <>
                    <div className="chargesDetail-row">
                      <p>CGST</p>
                      <p>{cgstAmount.toFixed(2)}</p>
                    </div>
                    <div className="chargesDetail-row">
                      <p>SGST</p>
                      <p>{sgstAmount.toFixed(2)}</p>
                    </div>
                  </>
                 )}
               <div className="chargesDetail-row">
                 <p>Total Amount</p>
                 <p>{Number(totalAmount).toFixed(2)}</p>
               </div>
             </div>
      </div>
                 <UploadInvoiceFormBottom border="1px solid #7C144B" onClose={(e,i)=>onClose(e,i)} docs={invoiceFormData ? invoiceFormData : null} filterToggle={filterToggle} showUploadBtn={true} />
                  <div className='margin-div-edit-invoice' style={{marginBottom:"10rem"}}></div>
            <div className="AcceptButtons-ContainerParent">
                   <div className="AcceptButtons-Container">
                     <AcceptButtons disabled={!allParameterValuesNotEmpty} background={allParameterValuesNotEmpty?"rgb(233, 77, 81)":"#F7BDBE"} color={allParameterValuesNotEmpty?"rgb(255, 255, 255)":"#E42125"} datatestid="AddNewInvoice3" onClick={onSubmit}>Submit</AcceptButtons>
                   </div>
                 </div>
  {open && (<FilterPopUp open={open} backgroundColor={'#8F949B80'} filterToggle={filterToggle} >
        <DocumentUpload uploadDocuments={uploadDocuments}  docsUploaded={docsUploaded} setDocsUploaded={setDocsUploaded}/>
      </FilterPopUp>)}
      {showLoader && <Loader />}
      {showSuccessMessage && (
        <SuccessMessage message="Records Updated Successfully!" delay={3000} />
      )}
         <ErrorAlert
              modal={modal}
              toggle={toggle}
              modalTitle={modalTitle}
              modalBody={modalBody}
            />
</div>
  )
}

export default index